import type { CSSObject } from "@emotion/react";
import { space, typography } from "@ecco/ui/tokens";

const { fontSizes } = typography;

const accordionText = {
    fontSize: "desktopBodyTextSmall",
    fontWeight: "normal",
};

export const accordionStyles = {
    accordionItem: {
        w: "100%",
        backgroundColor: "transparent",
        borderRadius: 0,
        borderTopWidth: space["0.2"],
        borderBottomWidth: space["0.2"],
        borderColor: "gray.100",
    },

    accordionButtonProps: {
        w: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "transparent",
        color: "black",
        fontWeight: "semibold",
        fontSize: ["mobileBodyTextNormal", "mobileBodyTextNormal", "desktopBodyTextLarge"],
        py: 4,
        px: 0,
        borderRadius: 0,
        _hover: { backgroundColor: "transparent" },
        _expanded: { backgroundColor: "transparent" },
    },

    accordionChevronIconProps: {
        boxSize: "1.5rem",
        transition: "transform 0.25s ease",
    },

    accordionHeaderText: {
        fontSize: { base: "mobileBodyTextSmall", lg: "desktopBodyTextSmall" },
        fontWeight: "bold",
    },

    accordionListItem: {
        ...accordionText,
        _notFirst: { marginTop: 4 },
    },

    accordionPanel: {
        px: 0,
        fontSize: "desktopBodyTextSmall",
        "& ul li": {
            fontSize: "desktopBodyTextSmall",
            "& p": { mb: 0.5 },
        },
    },

    accordionBenefitsPanelProps: {
        pb: 0,
        pl: 1,
        fontSize: "desktopBodyTextSmall",
    },

    accordionBenefitsPanelContentCss: {
        "& ul li": {
            fontSize: fontSizes.desktopBodyTextSmall,
            "& p": { marginBottom: space["0.4"] },
        },
    } satisfies CSSObject,

    itemId: {
        fontSize: ["mobileBodyTextTiny", "desktopBodyTextTiny"],
        fontWeight: "bold",
        mt: 4,
        color: "gray.600",
    },

    itemDescription: {
        ...accordionText,
        color: "black",
        lineHeight: "short",
        fontWeight: "normal",
        mt: 2,
    },
};

export const uspStyles = {
    container: {
        display: "flex",
        alignItems: "center",
        py: 2,
    },

    iconWrapper: {
        width: space["4"],
        minWidth: space["4"],
        mr: 2,
    },

    textWrapper: {
        display: "block",
        fontSize: "desktopBodyTextSmall",

        "& p": {
            margin: 0,
            display: "inline",
        },
    },

    tooltipIcon: {
        display: "inline-flex",
        verticalAlign: "middle",
        marginLeft: "4px",
        cursor: "pointer",
    },
};
